export default function (data, property) {
    return data.map(function (item) {
        return item[property]
    })
}